var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content",attrs:{"role":"status","aria-live":"polite"}},[_c('p',{staticClass:"alert",class:_vm.levelClass},[_c('strong',[_vm._v("Error!")]),_vm._v(" "+_vm._s(_vm.message)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }